module.exports = __webpack_public_path__ + "static/media/logo-dark-ca.9cb6ae71.png";